import {
  CurrencyAmountForm,
  InfoCard,
  Loader,
  ServiceFeeDisplay,
} from '@/shared/components';
import { useCurrencyAmountFormConfig } from '@/shared/lib/formConfigFactory';
import { useTranslation } from 'react-i18next';
import type { DepositSberpayFormProps } from '@/features/deposit-sberpay/model';

export function DepositSberpayForm({
  form,
  handleFormSubmit,
  currencyOptions,
  minAmount,
  amountPlaceholder,
  commissionData,
  shouldShowCommission,
  formError,
  isLoading,
  className,
  footerInfo,
}: DepositSberpayFormProps) {
  const { t } = useTranslation();

  const formConfig = useCurrencyAmountFormConfig({
    currencyOptions,
    minAmount,
    currencyLabelKey: 'common.currencyPlaceholder',
    amountLabelKey: 'common.amount',
    amountPlaceholderKey: amountPlaceholder,
    showSubmitButton: false,
    cancelButtonKey: 'common.cancel',
    customContentAfterFields:
      shouldShowCommission && commissionData ? (
        <ServiceFeeDisplay
          commissionData={commissionData}
          className="mt-[-1.2rem]"
        />
      ) : undefined,
    customContentBeforeSubmit: (
      <>
        {footerInfo && (
          <InfoCard title={t('depositMethods.sberpay.limits.title')}>
            <div className="text-[1.4rem] text-muted-foreground space-y-[0.4rem]">
              {footerInfo.split('\n').map(text => (
                <div key={text}>{text}</div>
              ))}
            </div>
          </InfoCard>
        )}

        <InfoCard title={t('depositMethods.sberpay.confirmation.title')}>
          <div className="text-[1.4rem] text-muted-foreground">
            {t('depositMethods.sberpay.confirmation.description')}
          </div>
        </InfoCard>
      </>
    ),
    className,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-[4rem]">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-[1.6rem]">
      <CurrencyAmountForm
        config={formConfig}
        form={form}
        onSubmit={handleFormSubmit}
        error={formError}
      />
    </div>
  );
}
